import { useRef, type ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { PeersheepLoader } from "@/components/ui/square-loader";

/**
 * For /login and /signup: someone who is already signed in when they land
 * here goes straight to the dashboard. Only the state on arrival counts —
 * signing in on the page leaves navigation to the page itself (signup sends
 * new accounts to /onboarding, login to /dashboard).
 */
export function GuestRoute({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth();
  // Decided once, the first time the session check finishes
  const arrivedSignedIn = useRef<boolean | null>(null);

  if (isLoading && arrivedSignedIn.current === null) {
    return (
      <div className="flex h-screen items-center justify-center">
        <PeersheepLoader size="lg" label="Loading" />
      </div>
    );
  }

  if (arrivedSignedIn.current === null) arrivedSignedIn.current = isAuthenticated;
  if (arrivedSignedIn.current) return <Navigate to="/dashboard" replace />;

  return <>{children}</>;
}
